export const size = [
  { "name": "Free", "value": "free" },
  { "name": "2mm", "value": "2mm" },
  { "name": "4mm", "value": "4mm" },
  { "name": "6mm", "value": "6mm" },
  { "name": "8mm", "value": "8mm" },
  { "name": "12mm", "value": "12mm" }
]
